<template>
  <div>
    <div class="timeRadio">
      <el-date-picker
        v-model="dateDepartMent"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        :clearable="false"
        @change="selectDepartDate"
      >
      </el-date-picker>
      <el-radio-group v-model="radioVal" size="mini" @input="changeDate">
        <el-radio-button label="yesterDay">昨日</el-radio-button>
        <el-radio-button label="week">近一周</el-radio-button>
      </el-radio-group>
    </div>
    <div id="manageId"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import { getexportDepartmentData } from "@/api/doOneGood";
export default {
  name: "Statistical",
  data() {
    return {
      radioVal: "yesterDay",
      xAxisList: [],
      chartsData: [],
      myChart: "",
      dateDepartMent: []
    };
  },
  mounted() {
    setTimeout(() => {
      this.initEcharts();
      this.changeDate("yesterDay");
    }, 500);
  },
  methods: {
    initEcharts() {
      var chartDom = document.getElementById("manageId");
      var chartsOption = {
        title: {
          text: "部门得分排名"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisList,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "（得分）"
          }
        ],
        series: [
          {
            name: "得分",
            type: "bar",
            barWidth: "60%",
            data: this.chartsData,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
          }
        ]
      };
      this.myChart = echarts.init(chartDom);
      chartsOption && this.myChart.setOption(chartsOption);
    },
    async changeDate(val) {
      switch (val) {
        case "yesterDay":
          this.startTime = moment()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.endTime = moment()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
        case "week":
          this.startTime = moment()
            .startOf("week")
            .format("YYYY-MM-DD HH:mm:ss");
          this.endTime = moment()
            .endOf("week")
            .format("YYYY-MM-DD HH:mm:ss");

          break;

        default:
          break;
      }
      this.dateDepartMent = [this.startTime, this.endTime];
      this.getDepartData();
    },
    async getDepartData() {
      const params = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      const { code, data } = await getexportDepartmentData(params);
      if (code != "0") return;
      this.xAxisList = data.map(el => {
        return el[0];
      });
      this.chartsData = data.map(el => {
        return el[1];
      });

      this.myChart.setOption({
        xAxis: [{ data: this.xAxisList }],
        series: [{ data: this.chartsData }]
      });
    },
    selectDepartDate(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      this.getDepartData();
    }
  }
};
</script>

<style>
#manageId {
  width: 100%;
  height: 280px;
  /* height: 40%; */
}
.timeRadio {
  position: absolute;
  right: 6%;
}
</style>



// WEBPACK FOOTER //
// src/components/OneGoodModule/Statistical.vue